export default __webpack_public_path__ + "static/media/cross.7b3feef5.svg";